export const adminUser = "zidr-admin";
